import CabinBaggagePostbooking from '../components/CabinBaggagePostbooking';
import CabinBaggagePrimaryFlow from './CabinBaggagePrimaryFlowContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const CabinBaggageContainer = _ref => {
  let {
    bundleData,
    form,
    includedBaggage,
    isBaggageAvailableOrIncluded,
    isPostBooking,
    order,
    readMore,
    productPosition,
    shouldUseCarrierSpecificUnavailableLabel,
    travelerNumber
  } = _ref;
  if (isPostBooking) {
    return /*#__PURE__*/_jsx(CabinBaggagePostbooking, {
      order: order
    });
  }
  return /*#__PURE__*/_jsx(CabinBaggagePrimaryFlow, {
    bundleData: bundleData,
    form: form,
    includedBaggage: includedBaggage,
    isBaggageAvailableOrIncluded: isBaggageAvailableOrIncluded,
    order: order,
    productPosition: productPosition,
    readMore: readMore,
    shouldUseCarrierSpecificUnavailableLabel: shouldUseCarrierSpecificUnavailableLabel,
    travelerNumber: travelerNumber
  });
};
export default CabinBaggageContainer;
//# sourceMappingURL=CabinBaggageContainer.js.map